import { Http } from "@/api/http";

export abstract class ApiBase {
  protected readonly http = Http;
}
